import React, { useState, useEffect, useContext } from "react";
import { Row, Col, Button, Modal, Form } from "react-bootstrap";
import ModalInputText from "./ModalInputText";
import { Store } from "react-notifications-component";
import PermissionContext from "../../../Store/permission-context";

const EditSupplyModal = (props) => {
  const PCtx = useContext(PermissionContext);
  const [ShowModal, setShowModal] = useState(props.show);
  const [Itemname, setItemname] = useState(props.Suprec.GoodName);
  const [ThisQBulk, setThisQBulk] = useState(props.Suprec.QBulk2);
  const [ThisQUnit, setThisQUnit] = useState(props.Suprec.QUnit);
  const [ThisDate, setThisDate] = useState(props.Suprec.DateSupplied);
  const [ThisSupplier, setThisSupplier] = useState(props.Suprec.Supplier);
  const [ThisSoldin, setThisSoldin] = useState(props.Suprec.Soldin);
  const [ThisCostPrice, setThisCostPrice] = useState(props.Suprec.CostPrice);
  const [ThisConverter, setThisConverter] = useState(props.Suprec.Converter);
  const [InitialThisQBulk, setInitialThisQBulk] = useState(props.Suprec.QBulk2);
  const [InitialThisQUnit, setInitialThisQUnit] = useState(props.Suprec.QUnit);

  let errorbackground = {
    backgroundColor: "#f04e00",
    fontFamily: "Times New Roman",
  };
  let successbackground = {
    backgroundColor: "#00ca65",
    fontFamily: "Times New Roman",
  };
  const [errorBackStyle, seterrorBackStyle] = useState(errorbackground);
  const [successBackStyle, setsuccessBackStyle] = useState(successbackground);

  const cancelM = () => {
    setShowModal(false);
    props.cancelModal();
  };

  const saveTheRecord = (e) => {
    e.preventDefault();
    let NewRec = {
      NEid: props.Suprec.EID,
      NGid: props.Suprec.GID,
      NSoldin: props.Suprec.Soldin,
      NGoodName: Itemname,
      NQBulk: ThisQBulk,
      NQUnit: ThisQUnit,
      Converter: ThisConverter,
      CostPrice: ThisCostPrice,
      OldQBulk: InitialThisQBulk,
      OldQUnit: InitialThisQUnit,
      Dbase: props.Suprec.DBase,
      NSupplier: props.Suprec.Supplier,
      Staff: PCtx.Username,
      NDate: props.Suprec.DateSupplied,
    };

    props.SaveNewRecord(NewRec);
  };

  const ThisChange = (e) => {
    if (!isNaN(e.target.value)) {
      if (e.target.name === "Bulk") {
        setThisQBulk(e.target.value);
      } else {
        if (e.target.name === "Unit") {
          setThisQUnit(e.target.value);
        }
      }
    }
  };

  return (
    ShowModal && (
      <Modal
        show={ShowModal}
        onHide={cancelM}
        backdrop="static"
        keyboard={false}
      >
        <Modal.Header style={successBackStyle} closeButton>
          <Modal.Title>
            {"Editing Quantity of " +
              Itemname +
              " supplied on " +
              ThisDate +
              " by " +
              ThisSupplier}
          </Modal.Title>
        </Modal.Header>
        <Modal.Body
          style={{
            fontFamily: "Times New Roman",
          }}
        >
          <Form onSubmit={saveTheRecord}>
            <Row className="justify-content-around">
              <Col md={6} sm={6} xs={6}>
                <ModalInputText
                  Label={"Number of " + ThisSoldin}
                  Name="Bulk"
                  Val={ThisQBulk}
                  thischange={(e) => ThisChange(e)}
                />
              </Col>
              <Col md={6} sm={6} xs={6}>
                <ModalInputText
                  Label="Number of Units"
                  Name="Unit"
                  Val={ThisQUnit}
                  thischange={(e) => ThisChange(e)}
                />
              </Col>

              <Col md={4} sm={4} xs={4}>
                <Button variant="outline-danger" onClick={cancelM}>
                  Cancel
                </Button>
              </Col>
              <Col md={4} sm={4} xs={4}>
                <Button variant="outline-success" type="submit">
                  Save
                </Button>
              </Col>
            </Row>
          </Form>
        </Modal.Body>
      </Modal>
    )
  );
};

export default EditSupplyModal;
